import { render, staticRenderFns } from "./NotFoundScreen.vue?vue&type=template&id=55fb1c0d"
import script from "./NotFoundScreen.vue?vue&type=script&lang=js"
export * from "./NotFoundScreen.vue?vue&type=script&lang=js"
import style0 from "./NotFoundScreen.vue?vue&type=style&index=0&id=55fb1c0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports